import { Injectable } from '@angular/core';

import { MapDatePipe } from '../../shared/data-table/pipes/map-date.pipe';
import { MapNumberPipe } from '../../shared/data-table/pipes/map-number.pipe';

@Injectable({ providedIn: 'root' })
export class FormattingService {
  constructor(
    private readonly mapDatePipe: MapDatePipe,
    private readonly mapNumberPipe: MapNumberPipe,
  ) {}

  asString(value?: any) {
    return value?.toString() || '';
  }

  asYesNo(value?: boolean) {
    return typeof value === 'boolean' ? (value ? 'Yes' : 'No') : '';
  }

  asAmount(value?: number, currency?: string) {
    const amount = this.mapNumberPipe.transform(value) + (currency ? ` ${currency}` : '');
    return isNaN(value) ? '' : amount;
  }

  asNumber(value?: number, digitInfo = '1.2-2') {
    return isNaN(value) ? '' : this.mapNumberPipe.transform(value, digitInfo);
  }

  asPercent(value?: number) {
    return typeof value === 'number' ? this.mapNumberPipe.transform(value) + '%' : '';
  }

  asDate(value: string) {
    const ms = Date.parse(value);
    return isNaN(ms) ? '' : this.mapDatePipe.transform(ms);
  }
}
